import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import fb_logo from '../assets/images/icon_facebook_black.svg';
import twitter_logo from '../assets/images/icon_twitter_black.svg';


const styles = (theme) => ({
  container: {
    marginLeft: -theme.spacing.unit / 2,
    marginRight: -theme.spacing.unit / 2,
  },
  item: {
    display: 'inline-block',
    width: theme.spacing.unit * 2,
    height: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit / 2,
    marginRight: theme.spacing.unit / 2,
  }
});

function SocialShare(props) {
  const {classes} = props;

  return (
    <ul className={classes.container}>
      <li className={classes.item}>
        <a target="_blank"
           href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}>
          <img src={fb_logo} alt="Share on Facebook"/>
        </a>
      </li>
      <li className={classes.item}>
        <a target="_blank"
           href={`https://twitter.com/home?status=${window.location.href}`}>
          <img src={twitter_logo} alt="Share on Twitter"/>
        </a>
      </li>
    </ul>
  );
}


export default withStyles(styles)(SocialShare);



// WEBPACK FOOTER //
// ./src/parts/SocialShare.js